import { render, staticRenderFns } from "./ReviewsSettings.vue?vue&type=template&id=8cbd1e14&scoped=true&"
import script from "./ReviewsSettings.vue?vue&type=script&lang=js&"
export * from "./ReviewsSettings.vue?vue&type=script&lang=js&"
import style0 from "./ReviewsSettings.vue?vue&type=style&index=0&id=8cbd1e14&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8cbd1e14",
  null
  
)

export default component.exports